export default {
  NODE_ENV: process.env.NODE_ENV,
  API_URL: process.env.API_URL,
  topURL: process.env.topURL,
  IMAGE_URL: process.env.IMAGE_URL,
  PAY_URL: process.env.PAY_URL,
  CURRENT_URL: process.env.CURRENT_URL,
  CURRENT_URL2: process.env.CURRENT_URL2,
  mobileUrl: process.env.mobileUrl,
  host: process.env.host,
  URSE_URL: process.env.URSE_URL,
  ISDOMAIN: process.env.ISDOMAIN,
  WWW_URL: process.env.WWW_URL,
  WWW_IZHAOWO_URL: process.env.WWW_IZHAOWO_URL,
  TOP_URL: process.env.TOP_URL,
  APP_TENCENT_APPID: process.env.APP_TENCENT_APPID,
  NEW_BASE_URL: process.env.NEW_BASE_URL,
  CMS_URL: process.env.CMS_URL,
};



// WEBPACK FOOTER //
// ./src/config/api.js